import { GetUnreadCountResponse } from "subModule/src/services/Notifications/interface";
import { NotificationProfileService } from "subModule/src/core/services";
import AlertMessages from "common/Alert/AlertMessages";
import { setUnreadCount } from "features/user/notificationSlice";

export function CheckUnreadCount(id: number, dispatch: any, enqueueSnackbar: any) {
    NotificationProfileService.getUnreadCount(id)
      .then((res: GetUnreadCountResponse) => {
        if (res.success) {
          dispatch(setUnreadCount(res.data || 0));
        } else {
          enqueueSnackbar(<AlertMessages text={res?.message || "Something went wrong"} />, { variant: "error" });
        }
      }).catch((err: any) => console.error(err));
}